import { Routes } from '@angular/router';

/**
 * Root routes used when the application boots in standalone reports mode.
 *
 * Everything is lazy loaded so the teacher/admin bundle is unaffected.
 */
export const reportsAppRoutes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./reports-app-feature.routes').then((m) => m.reportsAppFeatureRoutes),
  },
];
